<script>
export default {
    name: 'IconPause'
}
</script>
<template>
    <svg
        class="base-icon icon-pause"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28 12v40H12V12h16zm24 0v40H36V12h16z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
